import { useModals } from "@/features/modals/hooks";
import { ListViewItem } from "@repo/skapa";
import { questionMarkCircleIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { trackAnalytics } from "@repo/utils";

import { useActiveProject } from "./ActiveProject";
import { useProjectQuestionnaire } from "./useProjectQuestionnaire";

export const NeedAnalysisListViewItem = () => {
  const { pushModal } = useModals();
  const { opportunity } = useActiveProject();
  const { answersLength, questionsLength, service } = useProjectQuestionnaire();

  if (!opportunity) {
    return null;
  }

  return (
    <ListViewItem
      leadingIcon={questionMarkCircleIcon}
      control="navigational"
      title={t("label.need_analysis_questionnaire")}
      description={t("label.need_analysis_question_length", {
        totalAnswers: answersLength,
        totalQuestions: questionsLength,
      })}
      onClick={() => {
        pushModal({
          type: "QUESTIONNAIRE",
          opportunityId: opportunity.id,
          selectedHfbs: opportunity?.hfb || [],
          service,
        });

        trackAnalytics("open_need_analysis_modal");
      }}
    />
  );
};
